import React from "react";
import DatePicker from "./DatePicker";


export default function DateRange({label, pickerOptions, ...props}) {
    return (
            <DatePicker options={{
                mode: "range",
                dateFormat: "Y-m-d",
                ...pickerOptions
            }} {...props} input={{fullWidth: true, label: label, sx: {marginTop: '8px', marginBottom: '8px'}}}/>
    );
}